import { Match } from "preact-router/match";
import Link from "../link";
import { mergeClasses } from "../helpers";

// Modified from: https://github.com/developit/preact-router/blob/13f185a0c1881bb118982c0782b8cea7604fc937/src/match.js
const MatchLink = ({
  href,
  activeClass = null,
  blank = null,
  class: className = null,
  ...props
}) => {
  return (
    <Match path={href}>
      {({ matches }) => (
        <Link
          href={href}
          blank={blank}
          class={mergeClasses([className, matches && activeClass])}
          {...props}
        />
      )}
    </Match>
  );
};

export default MatchLink;
